import { FormattedMessage } from "react-intl";
import MetaCard from "../MetaCard/MetaCard";

import scaleIcon from "../../../../assets/ecg-graph/scale.svg";

import styles from "./Scale.module.css";

const Scale = () => {
  return (
    <MetaCard className="mb-2 font-md">
      <p className="mb-2 prim-color-dark font-weight-bold">
        <FormattedMessage id="ECG_DETAILS.SCALE" defaultMessage="Scale" />:
      </p>
      <div className="d-flex align-items-start">
        <div className={styles.scaleWrapper}>
          <img src={scaleIcon} alt="" className="img-fluid" />
        </div>
        <div className="mx-1"></div>
        <table className="flex-grow-1">
          <tbody>
            <tr>
              <td className="pb-1">
                <FormattedMessage
                  id="ECG_DETAILS.SCALE.SPEED"
                  defaultMessage="Speed"
                />
                :
              </td>
              <td className="pb-1">
                25
                <span className="muted-color">
                  &nbsp;
                  <FormattedMessage
                    id="UNITS.MM_SEC"
                    defaultMessage="mm/Second"
                  />
                </span>
              </td>
            </tr>
            <tr>
              <td className="pb-1">
                <FormattedMessage
                  id="ECG_DETAILS.SCALE"
                  defaultMessage="Scale"
                />
                :
              </td>
              <td className="pb-1">
                2
                <span className="muted-color">
                  &nbsp;
                  <FormattedMessage
                    id="UNITS.SQUARES_MV"
                    defaultMessage="Squares/mV"
                  />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </MetaCard>
  );
};

export default Scale;
